async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service Worker não é suportado neste navegador.");
    return null;
  }

  // Apenas verifica se o OneSignal está registrado
  try {
    const registration = await navigator.serviceWorker.ready;
    if (registration && registration.active) {
      console.log("Service Worker do OneSignal está ativo");
      return registration;
    }
    return null;
  } catch (err) {
    console.error("Erro ao verificar Service Worker:", err);
    return null;
  }
}

async function sendMessageToSW(message) {
  try {
    const reg = await navigator.serviceWorker.ready;
    if (reg && reg.active) {
      reg.active.postMessage(message);
    } else {
      console.warn("Não há SW ativo para receber mensagem:", message);
    }
  } catch (err) {
    console.error("Erro ao enviar mensagem para SW:", err);
  }
}

// Exportações
export { registerServiceWorker as register, sendMessageToSW };
export default { register: registerServiceWorker, sendMessageToSW };

// Não registre automaticamente - deixe o OneSignal fazer isso
